<template>
  <div>
    <div class="toggle-option-box">
      <div class="text-left" style="width: 100%;">
        <slot></slot>
      </div>
      <div class="ml-3">
        <toggle-button
          :color="variable"
          :sync="true"
          :disabled="disabled"
          v-model="localValue"
        />
      </div>
    </div>
    <slot name="value"></slot>

    <div v-if="separator">
      <hr />
    </div>
  </div>
</template>

<script>
import variables from '@/styles/colors.scss';
export default {
  name: 'ToggleOption',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: null,
    separator: {
      type: Boolean,
      default: false,
    },
    colorName: {
      type: String,
      default: 'toggle',
    },
  },

  data() {
    return {
      localValue: false,
    };
  },

  watch: {
    value: function (newVal) {
      //console.log("ToggleOption new value:", newVal);
      this.localValue = newVal;
    },
  },

  computed: {
    variable() {
      const color = variables[this.colorName] || 'not found';
      console.log('toggle-color:', color);
      return color;
    },
  },
  created() {
    this.localValue = this.value;
    this.$watch('localValue', () => {
      this.$emit('input', this.localValue);
    });
  },
};
</script>

<style>
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.toggle-option-box {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
